﻿window.LBSApp = window.LBSApp || {};
window.LBSApp.ModalUtils = {
    create: function (modalContainer) {
        let originalTabIndexes = new Map();
        let originalAriaHiddenValues = new Map();
        let focusableElementsOnSite = [];
        let scrollLockedAtOpen = false;
        let focusedElementAtOpen = null;

        function init() {
            setAriaHidden(false);
        }

        function open() {
            // I want to get the currently focused element to be able to restore it when the modal is closed
            focusedElementAtOpen = document.activeElement;
            scrollLockedAtOpen = document.querySelector('.js-Site-container').classList.contains('locked');
            const focusableElementsSelector = 'button, a[href], input, select, textarea, video';

            const modalFocusableElements = Array.from(modalContainer.querySelectorAll(focusableElementsSelector));
            focusableElementsOnSite = Array.from(document.querySelectorAll(focusableElementsSelector))
                .filter(element =>
                    !modalFocusableElements.includes(element)
            );
            originalTabIndexes = getOriginalTabIndexes(focusableElementsOnSite);
            setTabIndex(focusableElementsOnSite, false);
            setTabIndex(modalFocusableElements, true);
            setAriaHidden(true);
            document.addEventListener('keydown', handleKeyDown);
            $(modalContainer).fadeIn('fast');
            document.querySelector('.js-Site-container').classList.add('locked');
            window.LBSApp.FocusUtils.focusAndAdjust(modalContainer.querySelector('.modal-content'));
            modalContainer.querySelector('.Modal-clickarea').addEventListener('click', close);
            modalContainer.querySelector('.Modal-close-form').addEventListener('click', close);
        }

        function close(evt) {
            if (evt) {
                evt.stopPropagation();
                evt.preventDefault();
            }
            restoreOriginalTabIndexes();
            setAriaHidden(false);
            document.removeEventListener('keydown', handleKeyDown);
            modalContainer.querySelector('.Modal-clickarea').removeEventListener('click', close);
            modalContainer.querySelector('.Modal-close-form').removeEventListener('click', close);
            $(modalContainer).fadeOut('fast');

            if (scrollLockedAtOpen == false) {
                document.querySelector('.js-Site-container').classList.remove('locked');
            }
            if (focusedElementAtOpen) {
                focusedElementAtOpen.focus();
            }
        }
        
        function getOriginalTabIndexes(elements) {
            const tabIndexes = new Map();
            elements.forEach(item => {
                tabIndexes.set(item, item.getAttribute('tabindex'));
            });
            return tabIndexes;
        }

        function restoreOriginalTabIndexes() {
            focusableElementsOnSite.forEach(item => {
                const originalTabIndex = originalTabIndexes.get(item);
                if (originalTabIndex !== null) {
                    item.setAttribute('tabindex', originalTabIndex);
                } else {
                    item.removeAttribute('tabindex');
                }
            });
        }

        function setTabIndex(els, tabbable) {
            els.forEach(el => {
                if (tabbable) {
                    el.removeAttribute('tabindex');
                } else {
                    el.setAttribute('tabindex', '-1');
                }
            });
        }

        function setAriaHidden(shouldOpen) {
            function setAriaHiddenToSiblings(element) {
                var siblings = Array.prototype.filter.call(element.parentNode.children, function (child) {
                    return child !== element;
                });

                siblings.forEach(function (sibling) {
                    originalAriaHiddenValues.set(sibling, sibling.getAttribute('aria-hidden'));
                    sibling.setAttribute('aria-hidden', 'true');
                });
            }

            function restoreAriaHiddenValues() {
                originalAriaHiddenValues.forEach(function (value, element) {
                    if (value === null) {
                        element.removeAttribute('aria-hidden');
                    } else {
                        element.setAttribute('aria-hidden', value);
                    }
                });
            }

            if (shouldOpen) {
                modalContainer.removeAttribute('aria-hidden');

                // set aria hidden on all siblings and all parent siblings
                originalAriaHiddenValues = new Map();
                setAriaHiddenToSiblings(modalContainer, true);
                var ancestor = modalContainer.parentNode;
                while (ancestor !== document.body) {
                    setAriaHiddenToSiblings(ancestor);
                    ancestor = ancestor.parentNode;
                }
            }
            else {
                modalContainer.setAttribute('aria-hidden', 'true');
                restoreAriaHiddenValues();
            }
        }

        function handleKeyDown(evt) {
            evt.stopPropagation();
            if (evt.key === 'Escape') {
                close();
            }
        }

        init();

        // Return an object with exposed methods
        return {
            open: open,
            close: close,
            setTabIndex: setTabIndex,
            setAriaHidden: setAriaHidden,
            getOriginalTabIndexes: getOriginalTabIndexes,
            restoreOriginalTabIndexes: restoreOriginalTabIndexes
        };
    }
}